import { render } from "./TotalExpenses.vue?vue&type=template&id=68f8bcd4&ts=true"
import script from "./TotalExpenses.vue?vue&type=script&lang=ts"
export * from "./TotalExpenses.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__